import { isMembersListResponse, } from '@urbanik/api-contracts';
export class MembersListApiError extends Error {
    kind;
    constructor(kind, message) {
        super(message);
        this.kind = kind;
        this.name = 'MembersListApiError';
    }
}
export async function getMembers(baseUrl, request = {}, signal) {
    const url = new URL(`${baseUrl.replace(/\/$/, '')}/identity/members`);
    for (const [key, value] of Object.entries(request))
        if (value !== undefined)
            url.searchParams.set(key, String(value));
    let response;
    try {
        response = await fetch(url, {
            headers: { Accept: 'application/json' },
            credentials: 'include',
            signal: signal ?? null,
        });
    }
    catch {
        throw new MembersListApiError('unavailable', 'No pudimos consultar los socios.');
    }
    if (response.status === 400)
        throw new MembersListApiError('invalid-request', 'Los parámetros de consulta no son válidos.');
    if (response.status === 401)
        throw new MembersListApiError('unauthorized', 'Debes iniciar sesión.');
    if (response.status === 403)
        throw new MembersListApiError('forbidden', 'No tienes permiso para consultar socios.');
    let payload;
    try {
        payload = await response.json();
    }
    catch {
        throw new MembersListApiError('invalid-response', 'El servidor devolvió una respuesta inválida.');
    }
    if (!response.ok)
        throw new MembersListApiError('unavailable', 'No pudimos consultar los socios.');
    if (!isMembersListResponse(payload))
        throw new MembersListApiError('invalid-response', 'El contrato de lista no es válido.');
    return payload;
}
